import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getMIPInvestorInvestmentValuationsData } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { mapLoansToRows } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/LoansCard/investorLoans.utils.ts';
import { InvestorLoanRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/LoansCard/investorLoans.types.ts';

interface Result {
	rows: InvestorLoanRow[];
	isLoading: boolean;
	isError: boolean;
}

export const useInvestorLoans = ({ investorId }: { investorId: string }): Result => {
	const valuationsQuery = useQuery({
		queryKey: [API_PATHS.MIP_INVESTOR_VALUATIONS_ID_GET, { investorId }],
		queryFn: ({ signal }) =>
			getMIPInvestorInvestmentValuationsData(
				API_PATHS.MIP_INVESTOR_VALUATIONS_ID_GET,
				{ investorId },
				signal
			),
	});

	const payload = valuationsQuery.data?.payload;

	const rows = useMemo(() => mapLoansToRows(payload?.loans), [payload]);

	return {
		rows,
		isLoading: valuationsQuery.isPending,
		isError: valuationsQuery.isError,
	};
};
